import React, { HTMLAttributes } from 'react';
import classNames from 'classnames';

import { useSelector } from '@ecommerce/nest-ssr/common';
import { NavCategoryInterface } from './nav.context';
import Link from 'atomic/link/link';
import './nav.desktop.scss';

const NavDesktop: React.FC<HTMLAttributes<HTMLElement>> = ({ className, ...props }) => {
    const nav: NavCategoryInterface[] | null = useSelector((state: { nav: NavCategoryInterface[]; }) => state.nav);
    const navClasses = classNames(className, 'nav');

    return (
        <nav className={navClasses} {...props}>
            <ul className="nav__list">
                {
                    nav.map(({ id: categoryId, title: categoryTitle, list }) => list.length > 0 && (
                        <li className="nav__list-item" key={categoryId}>
                            <Link className="nav__list-link" href="#" title={categoryTitle}
                                uppercase={true} rel="nofollow"
                            >
                                {categoryTitle}
                            </Link>
                            <div className="nav__dropdown">
                                <div className="nav__dropdown-list-wrapper">
                                    <ul className="nav__dropdown-list container">
                                        {
                                            list.map(({ id, url, title }) => (
                                                <li className="nav__dropdown-list-item" key={id}>
                                                    <Link className="nav__dropdown-list-link" href={url} title={title}>
                                                        {title}
                                                    </Link>
                                                </li>
                                            ))
                                        }
                                    </ul>
                                </div>
                            </div>
                        </li>
                    ))
                }
            </ul>
        </nav>
    );
};

export default NavDesktop;
